"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const useObjectiveComparative_1 = __importDefault(require("hooks/useObjectiveComparative/useObjectiveComparative"));
const ButtonAddInsights_1 = __importDefault(require("./ButtonAddInsights"));
const InsightSectionName_1 = __importDefault(require("./InsightSectionName"));
const InsightTextArea_1 = __importDefault(require("./InsightTextArea"));
const InsightRowSection = () => {
    const rows = (0, useObjectiveComparative_1.default)((state) => state.rows);
    const isViewGraph = (0, useObjectiveComparative_1.default)((state) => state.isViewGraph);
    const handleAddNewRow = (0, useObjectiveComparative_1.default)((state) => state.handleAddNewRow);
    const [textValue, setTextValue] = (0, react_1.useState)('');
    const [isAddNew, setIsAddNew] = (0, react_1.useState)(false);
    const handleOnBlur = () => {
        if (textValue) {
            handleAddNewRow(textValue);
            setTextValue('');
        }
        setIsAddNew(false);
    };
    return (react_1.default.createElement("div", { className: "flex flex-col mr-[12px] gap-[16px] bg-n-200 z-20 sticky left-0" },
        react_1.default.createElement("div", { className: "grow-0 flex-shrink-0 w-[148px] h-[60px] bg-n-200 top-0 sticky z-20" }),
        react_1.default.createElement("div", { className: "flex flex-col gap-[16px] rounded-[4px]" }, rows === null || rows === void 0 ? void 0 :
            rows.map((data) => (react_1.default.createElement(InsightSectionName_1.default, { key: data.order, data: data, isViewGraph: isViewGraph }))),
            isAddNew ? (react_1.default.createElement(InsightTextArea_1.default, { id: (rows === null || rows === void 0 ? void 0 : rows.length) + 1, textValue: textValue, handleOnChange: (e) => setTextValue(e.target.value), handleOnBlur: handleOnBlur, isViewGraph: isViewGraph })) : (react_1.default.createElement(ButtonAddInsights_1.default, { isEmptyRows: (rows === null || rows === void 0 ? void 0 : rows.length) === 0, setIsAddNew: setIsAddNew })))));
};
exports.default = InsightRowSection;
